// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"24db19f85d755c4c62a2","922":"bfebb05ff9a2cb352433"}[chunkId] + ".js";
};